import React from 'react';
import styles from '../../../OrderStatusPage.module.scss';
import classnames from 'classnames';
import capitalize from 'lodash/capitalize';
import { OrderStatusType } from '../helpers';
import { useTranslation } from 'react-i18next';
import { CustomIcon } from '@components';

interface OrderStatusTrackerFigureRowProps {
  orderStatus: OrderStatusType;
}

export const OrderStatusTrackerFigureRow: React.FC<
  OrderStatusTrackerFigureRowProps
> = ({
  orderStatus: {
    id,
    status,
    title,
    titleSecondary,
    subtitle,
    description,
    descriptionSecondary,
  },
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.orderStatusPageFigureRow}>
      <div
        className={classnames(
          styles.orderStatusPageFigureCircle,
          status && styles[`orderStatusPageFigureCircle${capitalize(status)}`],
        )}
      >
        {status === 'cancelled' ? (
          <CustomIcon
            name="warning"
            style={{
              color: '#ffffff',
              width: '24px',
            }}
          />
        ) : (
          id
        )}
      </div>
      <div className={styles.orderStatusPageFigureTextContainer}>
        <div className={styles.orderStatusPageFigureTitle}>
          {t(`orderStatus.figure.statuses.${title}`)}&nbsp;
          {titleSecondary && (
            <span
              className={classnames(
                styles.orderStatusPageFigureTitle,
                styles.orderStatusPageFigureTitleAppendix,
              )}
            >
              {t(`orderStatus.figure.statuses.paymentPending`)}
            </span>
          )}
        </div>
        {subtitle && (
          <div className={styles.orderStatusPageFigureSubtitle}>{subtitle}</div>
        )}
        {description && (
          <div className={styles.orderStatusPageFigureDescription}>
            {description}
          </div>
        )}
        {descriptionSecondary && (
          <div className={styles.orderStatusPageFigureDescriptionSecondary}>
            {descriptionSecondary}
          </div>
        )}
      </div>
    </div>
  );
};
